import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ConnectedUserRoute = () => {
  const userData = JSON.parse(sessionStorage.getItem('userData'));

  if (userData) {
    if (userData?.status === 'verified' || userData?.status === 'accepted') {
      if (userData?.role) {
        if(userData?.role.toLowerCase() === "admin") {
          return <Navigate to="/dashboard/admin" />;
        }
        else if(userData?.role.toLowerCase() === "investor") {
          return <Navigate to="/dashboard/investor" />;
        }
        else if(userData?.role.toLowerCase() === "member" || userData?.role?.toLowerCase() === "partner") {
          return <Navigate to="/dashboard" />;
        }
        else {
          return <Navigate to="/post-sign-in" />;
        }
      } else {
        return <Navigate to="/choose-role" />;
      }
    } else if(userData?.status === 'pending') {
      return <Navigate to="/post-sign-in" />;
    }
  } else {
    return <Outlet />;
  }
};

export default ConnectedUserRoute;
